var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { ChildComponent } from "../../../pages/modules/child-component";
import { SourceType } from "../../../../models/queries/queries.models";
import { NotificationType } from "../../../../services/basics/notification-client.service";
import * as Enumerable from "linq";
import { RouterConstants } from "../../../../configuration/router.constants";
import { QueriesEditor } from "../../../components/queries/queries-editor";
var BaseOdataTicketLines = /** @class */ (function (_super) {
    __extends(BaseOdataTicketLines, _super);
    function BaseOdataTicketLines(notificationService, i18N, queriesService, router) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.queriesService = queriesService;
        _this.router = router;
        return _this;
    }
    BaseOdataTicketLines.prototype.onActivated = function (item) {
        this.reLoad(item);
    };
    BaseOdataTicketLines.prototype.getPath = function () {
        return "TicketLines";
    };
    BaseOdataTicketLines.prototype.reLoad = function (item) {
        var _this = this;
        if (this.GetFilteringQuery()) {
            this.queriesService.getEntityModels().then(function (models) {
                var e_1, _a;
                var columns = [];
                var selectedModel = Enumerable.from(models).firstOrDefault(function (y) { return y.uri == _this.getPath(); });
                try {
                    for (var _b = __values(selectedModel.projectionProperties), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item_1 = _c.value;
                        var column = QueriesEditor.generateDefaultColumn(item_1, selectedModel);
                        ;
                        if (column.name == "mainPicks" || column.name == "bonusPicks") {
                            column.valueConverter = function (x) { return x ? Enumerable.from(x.split(",")).orderBy(function (x) { return Number(x); }).toJoinedString(",") : ""; };
                        }
                        columns.push(column);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                var oDataUrl = _this.GetFilteringQuery();
                _this.itemSource = {
                    source: oDataUrl,
                    sourceType: SourceType.ODataUrl,
                    columns: columns,
                    groupInitialFilters: true
                };
            }).catch(function (error) {
                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-loading-meta-data-for-query-editor-text'), NotificationType.Error);
            });
        }
    };
    BaseOdataTicketLines.prototype.reloadDataGrid = function () {
        this.dataGrid.reloadData();
    };
    BaseOdataTicketLines.prototype.onItemSelected = function (x) {
        var item = x.detail.item;
        this.router.navigateToRoute(RouterConstants.RouteNames.ManageTicketLine, {
            id: item.gamePlayerTicketLineId
        });
    };
    return BaseOdataTicketLines;
}(ChildComponent));
export { BaseOdataTicketLines };
